var path = '/app/pages/page-not-found/page-not-found.html';
var html = "Page not found!";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/page-not-found/page-not-found.html
// module id = 572
// module chunks = 0